<template>
  <label
    class="
      -mx-1
      hover:bg-tint
      hover:opacity-100
      opacity-60
      py-1
      px-2
      text-var-xs
      select-none
      inline-flex
      rounded-full
    "
  >
    <input type="radio" class="mr-1" v-bind="$attrs" v-on="$listeners" />
    <slot />
  </label>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>
